import React, {memo} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {STATE_COLORS} from 'common/colors';
import {Tooltip} from '@mui/material';

type StateType = string; // Partial<IState['typeId']>;

const tooltipmap = {
   'Not Suspended': 'Active',
   Monitoring: 'File Monitor',
};

const useStyles = makeStyles({
   icon: (props: {status: StateType}) => ({
      // content: ' ',
      flex: '0 0 1rem',
      width: '1rem',
      height: '1rem',
      display: 'inline-block',
      background:
         STATE_COLORS[props.status as keyof typeof STATE_COLORS] || STATE_COLORS['Not Suspended'],
      position: 'relative',
      marginRight: '.3rem',
      borderRadius: '5px',
   }),
});

const StateIcon = memo(({status}: {status: StateType}) => {
   //  console.debug(status);
   const classes = useStyles({status});
   let ttText = tooltipmap[status as keyof typeof tooltipmap] || status;
   return status ? (
      <Tooltip title={ttText}>
         <div className={classes.icon} />
      </Tooltip>
   ) : null;
});

export default StateIcon;
